import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3dd2e005"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 1,
  id: "home"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Loading = _resolveComponent("Loading");

  var _component_Swiper = _resolveComponent("Swiper");

  var _component_CmdPlayList = _resolveComponent("CmdPlayList");

  var _component_AlonePlay = _resolveComponent("AlonePlay");

  var _component_NewMusic = _resolveComponent("NewMusic");

  var _component_CmdMv = _resolveComponent("CmdMv");

  var _component_DjprogramVue = _resolveComponent("DjprogramVue");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createCommentVNode(" 骨架屏 "), !_ctx.isShow ? (_openBlock(), _createBlock(_component_Loading, {
    key: 0
  })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 轮播图 "), _createVNode(_component_Swiper, {
    swiperList: _ctx.swiperList
  }, null, 8
  /* PROPS */
  , ["swiperList"]), _createCommentVNode(" 推荐歌单 "), _createVNode(_component_CmdPlayList, {
    commendList: _ctx.commendList
  }, null, 8
  /* PROPS */
  , ["commendList"]), _createCommentVNode(" 独家放送 "), _createVNode(_component_AlonePlay, {
    aloneList: _ctx.aloneList
  }, null, 8
  /* PROPS */
  , ["aloneList"]), _createCommentVNode(" 最新音乐 "), _createVNode(_component_NewMusic, {
    newMusicList: _ctx.newMusicList
  }, null, 8
  /* PROPS */
  , ["newMusicList"]), _createCommentVNode(" 推荐mv "), _createVNode(_component_CmdMv, {
    cmdMvList: _ctx.commendMvList
  }, null, 8
  /* PROPS */
  , ["cmdMvList"]), _createCommentVNode(" 主播电台 "), _createVNode(_component_DjprogramVue, {
    djprogramList: _ctx.djprogramList
  }, null, 8
  /* PROPS */
  , ["djprogramList"])]))], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  );
}